import { getSystemBlock } from '@/api/main/main';
import { getCommonCode } from '@/api/common/common';
import store from '@/store';
import sessionStore from '@/utils/sessionStore'

export default {
  state: {
    /**
     * 시스템 상태
     *
     * @description
     * NEW: 리뉴얼 공지
     * SYS: 시스템 점검 공지
     * SVC: 서비스
     */
    systemState: undefined,
    /**
     * 공지 목록
     */
    systemNoticeList: [],

    /**
     * 공통코드
     */
    commonCodes: {},
  },

  mutations: {
    SET_SYSTEM_BLOCK_INFO: (state, { systemState, systemNoticeList }) => {
      state.systemState = systemState || state.systemState;
      state.systemNoticeList = systemNoticeList || state.systemNoticeList;
    },
    ADD_COMMON_CODES: (state, { codeGroup, codeList }) => {
      state.commonCodes = {
        ...state.commonCodes,
        [codeGroup]: codeList,
      };
    },
  },

  actions: {
    async checkSystemBlockInfo({ commit }) {
      try {
        const response = await getSystemBlock({});
        if (response.code !== 'SUC0000') throw new Error(response.message);

        if (response.result.list?.length) {
          commit('SET_SYSTEM_BLOCK_INFO', { systemState: 'SYS', systemNoticeList: response.result.list });
          return;
        }
        commit('SET_SYSTEM_BLOCK_INFO', { systemState: 'SVC', systemNoticeList: [] });
      } catch (error) {
        commit('SET_SYSTEM_BLOCK_INFO',  { systemState: 'SVC', systemNoticeList: [] });
        // console.error('[getSystemBlock]', error);
      }
    },

    async fetchCommonCodes({ commit, state }, codeGroup) {
      try {
        if (state.commonCodes[codeGroup]) return;

        const { code, message, result } = await getCommonCode({ codeGroup });

        if (code !== 'SUC0000') throw new Error(`${code}: ${message}`);

        if (result) commit('ADD_COMMON_CODES', { codeGroup, codeList: result });
      } catch (error) {
        console.error(error);
      }
    },
  },

  getters: {
    systemState: (state) => state.systemState,
    systemBlockInfo: (state) => state.systemNoticeList?.[0],
    commonCodes: (state) => state.commonCodes,
  },
};
